
import { defineComponent } from 'vue'
import DesktopWarning from "@/components/DesktopWarning/DesktopWarning.vue";


export default defineComponent({
  components:{DesktopWarning},
  // setup() {
    
  // },
})
